import i18next from 'i18next'
import { resolveI18NLanguageCode } from './languageMapping'

let applyingProfileLanguage = false

export function isApplyingProfileLanguage () {
  return applyingProfileLanguage
}

/**
 * Switch i18next UI language.
 * @param {string} code
 * @returns {Promise<void>}
 */
export async function applyI18NLanguageCode (code) {
  if (!code || i18next.language === code) {
    return
  }

  applyingProfileLanguage = true
  try {
    await i18next.changeLanguage(code)
  } finally {
    applyingProfileLanguage = false
  }
}

/**
 * Apply UI language from profile language id and/or API language row.
 * @param {{ languageId?: string | number, languageCode?: string, languageName?: string, languagesById?: Record<string, { code?: string, name?: string }> }} params
 * @returns {Promise<void>}
 */
export async function applyProfileLanguage ({ languageId, languageCode, languageName, languagesById }) {
  const entry = languageId != null && languagesById ? languagesById[languageId] : null
  const code = resolveI18NLanguageCode({
    code: languageCode || entry?.code,
    name: languageName || entry?.name
  })
  if (code) {
    await applyI18NLanguageCode(code)
  }
}
